import { Link } from 'react-router-dom';
import useNavigation from '../hooks/useNavigation';

// Intercept only the plain primary-button click. Modifier keys and middle
// clicks fall through to the browser so the underlying <a href> opens in a
// new tab/window. Right-click never fires `click`, so no special handling.
function shouldInterceptClick(event) {
  return (
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey
  );
}

function buildClickHandler({ navigate, fallbackOnClick }) {
  return (event) => {
    if (fallbackOnClick) fallbackOnClick(event);
    if (event.defaultPrevented) return;
    if (!shouldInterceptClick(event)) return;
    event.preventDefault();
    navigate();
  };
}

export function ArticleLink({
  articleId,
  context = {},
  pageState = {},
  onClick,
  children,
  ...rest
}) {
  const { navigateToArticle } = useNavigation();
  const handleClick = buildClickHandler({
    navigate: () => navigateToArticle(articleId, { context, pageState }),
    fallbackOnClick: onClick,
  });
  return (
    <Link to={`/article/${articleId}`} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}

export function TopicLink({
  topicId,
  context = {},
  pageState = {},
  onClick,
  children,
  ...rest
}) {
  const { navigateToTopic } = useNavigation();
  const handleClick = buildClickHandler({
    navigate: () => navigateToTopic(topicId, { context, pageState }),
    fallbackOnClick: onClick,
  });
  return (
    <Link to={`/topics/${topicId}`} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
